import { useState } from 'react';

const EyeIcon = ({ off = false }) => {
  if (off) {
    return (
      <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M2 12s3.6-7 10-7c1.8 0 3.43.55 4.87 1.39" />
        <path d="M22 12s-3.6 7-10 7c-1.8 0-3.43-.55-4.87-1.39" />
        <path d="M14.12 14.12a3 3 0 01-4.24-4.24" />
        <path d="M3 3l18 18" />
      </svg>
    );
  }

  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

const PasswordField = ({
  id,
  name = 'password',
  value,
  onChange,
  placeholder,
  error,
  required,
  autoComplete = 'current-password',
  className = 'form-control',
  disabled = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="position-relative">
      <input
        id={id}
        name={name}
        type={showPassword ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: '2.75rem' }}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        aria-invalid={Boolean(error)}
        disabled={disabled}
      />
      <button
        type="button"
        className="btn btn-link text-secondary position-absolute top-50 end-0 translate-middle-y d-inline-flex align-items-center justify-content-center p-0 me-2"
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => setShowPassword((visible) => !visible)}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        aria-pressed={showPassword}
        disabled={disabled}
      >
        <EyeIcon off={showPassword} />
      </button>
    </div>
  );
};

export default PasswordField;
